module.exports = __webpack_public_path__ + "static/media/section-arrow-right.e8a777f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/section-arrow-right.svg
// module id = 478
// module chunks = 7